<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12">
        <label>{{ regional }}</label>
      </SGPColComponent>
    </SGPRowComponent>
    <hr>
  </div>
</template>

<script>

export default {
  name: "RegionalConfiguradaComponent",

  props: {
    regional: {
      type: Object,
      required: false
    }
  },
}
</script>